module.exports = __webpack_public_path__ + "img/c00_buildingtechchisel_Normal_ua.2a24eeb5.webp";